import request from '@/utils/request'

let TuiguangApi = {

  /*推广信息设置列表*/
  list(data) {
    return request._post('/shop/plus.tuiguang.Index/index', data);
},
/*添加推广信息设置*/
add(data) {
    return request._post('/shop/plus.tuiguang.Index/add', data);
},
/*修改推广信息设置*/
edit(data) {
    return request._post('/shop/plus.tuiguang.Index/edit', data);
},
/*删除推广信息设置*/
del(data) {
    return request._post('/shop/plus.tuiguang.Index/del', data);
},
/*推广信息设置详情*/
detail(data) {
  return request._post('/shop/plus.tuiguang.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.tuiguang.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.tuiguang.Setting/getSetting', data, errorback);
    },
}
export default TuiguangApi;



// WEBPACK FOOTER //
// ./src/api/tuiguang.js